import React, { useState } from 'react';
import { motion } from 'framer-motion';

export const CooperativeLandingPage: React.FC = () => {
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [memberCount] = useState(23); // Dynamic counter

  const handleSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // TODO: Implement actual signup API call
    setTimeout(() => {
      setIsSubmitting(false);
      alert('Parabéns! Você é agora um dos fundadores do QRSP Cooperative. Te chamaremos no WhatsApp em 24 horas.');
    }, 1500);
  };

  return (
    <div className="landing-page bg-gradient-to-br from-blue-50 to-green-50">
      {/* Navigation */}
      <div className="bg-white shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white text-xl font-bold">Q</span>
              </div>
              <h1 className="text-xl font-bold text-gray-900">QRSP Cooperative</h1>
            </div>
            <div className="text-sm text-gray-600">
              <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full font-semibold">
                {memberCount}/100 motoristas
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
              🚗 <span className="text-blue-600">Motoristas de São Paulo</span>
            </h1>
            <div className="text-2xl lg:text-4xl text-gray-800 mb-8 leading-tight">
              E se <span className="bg-yellow-200 px-2 rounded">100 de vocês</span> se juntassem<br/>
              para <span className="text-blue-600 font-semibold">construir ferramentas</span><br/>
              que aumentam a renda de <span className="text-green-600 font-bold">TODOS?</span>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="bg-white p-8 rounded-2xl shadow-xl max-w-2xl mx-auto mb-12"
          >
            <div className="text-lg text-gray-700 mb-6">
              <div className="flex items-center justify-center mb-4">
                <span className="text-4xl mr-3">👨‍💻</span>
                <span className="font-semibold">Eu sou o desenvolvedor</span>
              </div>
              <div className="space-y-2">
                <p>💰 <strong>Você investe R$ 15/semana</strong></p>
                <p>🛠️ <strong>Eu construo uma ferramenta nova</strong> toda semana</p>
                <p>🤝 <strong>Juntos, melhoramos</strong> semana após semana</p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* The Math */}
        <div className="bg-gray-900 text-white p-8 rounded-2xl mb-16">
          <h2 className="text-3xl font-bold text-center mb-8">📊 A Matemática é Simples</h2>
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-xl font-semibold mb-4 text-red-300">🚫 Como é hoje:</h3>
              <ul className="space-y-2 text-gray-300">
                <li>• Uber/99 fazem <strong className="text-white">BILHÕES</strong> com seu trabalho</li>
                <li>• Você ganha R$ 3.000-4.000/mês</li>
                <li>• Cada motorista resolve problemas sozinho</li>
                <li>• Sem poder de negociação coletiva</li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-4 text-green-300">✅ Como pode ser:</h3>
              <div className="bg-green-900 p-4 rounded-lg">
                <div className="text-2xl font-bold mb-2">
                  R$ 15 × 100 motoristas = <span className="text-green-300">R$ 1.500/semana</span>
                </div>
                <p className="text-green-100">
                  = <span className="text-green-300">R$ 6.000/mês</span> para desenvolvedor<br/>
                  = <strong>Nova ferramenta toda semana</strong>
                </p>
              </div>
              <p className="text-sm text-gray-400 mt-2">
                R$ 15 = Preço de meia corrida para ter seu próprio desenvolvedor!
              </p>
            </div>
          </div>
        </div>

        {/* Incremental Progress */}
        <div className="bg-white p-8 rounded-2xl shadow-lg mb-16">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">
            📈 Como Funciona: Construção Incremental
          </h2>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <span className="text-blue-600 text-2xl font-bold">1</span>
              </div>
              <h4 className="font-semibold mb-2">Semana 1</h4>
              <p className="text-sm text-gray-600">WhatsApp grupo VIP + Dashboard básico de ganhos</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <span className="text-green-600 text-2xl font-bold">2</span>
              </div>
              <h4 className="font-semibold mb-2">Semana 2</h4>
              <p className="text-sm text-gray-600">Sistema de comparação de ganhos entre regiões</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <span className="text-purple-600 text-2xl font-bold">3</span>
              </div>
              <h4 className="font-semibold mb-2">Semana 3</h4>
              <p className="text-sm text-gray-600">Mapa de preços de gasolina + descontos em grupo</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <span className="text-orange-600 text-2xl font-bold">∞</span>
              </div>
              <h4 className="font-semibold mb-2">Semana +</h4>
              <p className="text-sm text-gray-600">Vocês decidem! Surge alerts, eventos, parcerias...</p>
            </div>
          </div>
          <div className="text-center mt-8">
            <p className="text-gray-600 mb-4">
              <strong>Uma melhoria por semana.</strong> Construção constante baseada no feedback de vocês.
            </p>
            <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-blue-500">
              <p className="text-blue-800 font-medium text-lg">
                💡 <strong>"Se você acha ISSO uma boa ideia, imagina o que podemos fazer com as SUAS ideias!"</strong>
              </p>
              <p className="text-blue-700 text-sm mt-2">
                100 motoristas experientes = 100 perspectivas diferentes = infinitas possibilidades
              </p>
            </div>
          </div>
        </div>

        {/* What You Get */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            O que você ganha por <span className="text-green-600">R$ 15/semana?</span>
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="bg-white p-6 rounded-xl shadow-lg"
            >
              <div className="text-4xl mb-4">👨‍💻</div>
              <h3 className="font-bold text-lg mb-3">Desenvolvedor Pessoal</h3>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• WhatsApp direto comigo</li>
                <li>• Atualizações semanais</li>
                <li>• Você decide as funcionalidades</li>
                <li>• Suporte personalizado</li>
              </ul>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="bg-white p-6 rounded-xl shadow-lg"
            >
              <div className="text-4xl mb-4">🤝</div>
              <h3 className="font-bold text-lg mb-3">Rede de Motoristas</h3>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Grupo VIP de 100 motoristas</li>
                <li>• Compartilhar dicas e rotas</li>
                <li>• Oportunidades em grupo</li>
                <li>• Aprender com os melhores</li>
              </ul>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-white p-6 rounded-xl shadow-lg"
            >
              <div className="text-4xl mb-4">🛠️</div>
              <h3 className="font-bold text-lg mb-3">Ferramentas Exclusivas</h3>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Otimização de rotas</li>
                <li>• Análise de ganhos</li>
                <li>• Previsão de surge</li>
                <li>• Descontos em grupo</li>
              </ul>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="bg-white p-6 rounded-xl shadow-lg"
            >
              <div className="text-4xl mb-4">💰</div>
              <h3 className="font-bold text-lg mb-3">Renda Extra</h3>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Parcerias com estabelecimentos</li>
                <li>• Negociações em grupo</li>
                <li>• Eventos coordenados</li>
                <li>• Sem taxa de comissão</li>
              </ul>
            </motion.div>
          </div>
        </div>

        {/* Social Proof */}
        <div className="bg-white p-8 rounded-2xl shadow-lg mb-16">
          <h2 className="text-2xl font-bold text-center mb-8">
            🌟 Motoristas Fundadores Já Confirmaram
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <span className="text-blue-600 text-2xl font-bold">JS</span>
              </div>
              <h4 className="font-semibold">João Silva</h4>
              <p className="text-sm text-gray-600">Fundador #1 • Ipiranga</p>
              <p className="text-sm italic mt-2">
                "Cansei de trabalhar sozinho. Hora de nos unirmos!"
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <span className="text-green-600 text-2xl font-bold">MP</span>
              </div>
              <h4 className="font-semibold">Maria Pereira</h4>
              <p className="text-sm text-gray-600">Fundadora #7 • Vila Madalena</p>
              <p className="text-sm italic mt-2">
                "Finalmente alguém que trabalha PARA nós, não contra!"
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <span className="text-purple-600 text-2xl font-bold">RS</span>
              </div>
              <h4 className="font-semibold">Roberto Santos</h4>
              <p className="text-sm text-gray-600">Fundador #15 • Consolação</p>
              <p className="text-sm italic mt-2">
                "R$ 50 é o que gastava de cafézinho. Agora vai render!"
              </p>
            </div>
          </div>
        </div>

        {/* Urgency */}
        <div className="bg-orange-100 border-l-4 border-orange-500 p-6 mb-12">
          <div className="flex items-center">
            <div className="text-2xl mr-4">⚡</div>
            <div>
              <h3 className="text-xl font-bold text-orange-800 mb-2">
                Oferta Limitada: Fundadores Pagam Menos
              </h3>
              <p className="text-orange-700">
                <strong>Primeiros 50 motoristas:</strong> R$ 10/semana para sempre<br/>
                <strong>Depois dos 50:</strong> R$ 15/semana (preço normal)<br/>
                <strong>Restam apenas:</strong> <span className="font-bold">{50 - memberCount} vagas</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-blue-600 py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Quero ser um dos 100 fundadores!
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Vamos construir o futuro dos motoristas paulistas juntos
          </p>

          <form onSubmit={handleSignup} className="bg-white p-8 rounded-xl shadow-xl max-w-md mx-auto">
            <div className="space-y-4 mb-6">
              <div>
                <input
                  type="text"
                  placeholder="Seu nome completo"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
              </div>
              <div>
                <input
                  type="tel"
                  placeholder="Seu WhatsApp: (11) 99999-9999"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
              </div>
            </div>
            
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-green-600 text-white py-4 rounded-lg font-bold text-lg hover:bg-green-700 transition-colors disabled:opacity-50"
            >
              {isSubmitting ? 'Enviando...' : '🚀 QUERO CONTRATAR MEU DESENVOLVEDOR!'}
            </button>
            
            <p className="text-xs text-gray-500 mt-4 text-center">
              Sem compromisso. Cancele quando quiser. Primeira semana grátis.
            </p>
          </form>
        </div>
      </div>

      {/* FAQ */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Perguntas Frequentes
        </h2>
        
        <div className="space-y-6">
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <h3 className="font-bold text-lg mb-2">🤔 Como sei que você vai entregar?</h3>
            <p className="text-gray-600">
              Você pode ver exatamente o que já construí em <strong>qrsp.app/demo</strong>. 
              Toda semana mostro progresso no WhatsApp. Se não gostar, cancela.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <h3 className="font-bold text-lg mb-2">💰 E se não conseguir 100 motoristas?</h3>
            <p className="text-gray-600">
              Com 30 motoristas: R$ 450/semana = meio-período para vocês.<br/>
              Com 50: R$ 750/semana = viável tempo parcial.<br/>
              Com 100: R$ 1.500/semana = desenvolvedor tempo integral!
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <h3 className="font-bold text-lg mb-2">🛠️ Que tipo de ferramenta você vai construir?</h3>
            <p className="text-gray-600 mb-3">
              Vocês decidem! Pode ser rastreamento de ganhos, otimização de rotas, 
              parcerias com postos, coordenação de eventos. O que for mais útil para o grupo.
            </p>
            <p className="text-blue-700 font-medium text-sm">
              💡 As melhores ideias sempre vêm dos motoristas que vivem a realidade das ruas todo dia!
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <h3 className="font-bold text-lg mb-2">📱 Preciso entender de tecnologia?</h3>
            <p className="text-gray-600">
              Não! Eu cuido de toda a parte técnica. Vocês só usam as ferramentas 
              e me falam o que querem melhorar.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-900 text-white py-12">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
              <span className="text-white text-sm font-bold">Q</span>
            </div>
            <h3 className="text-xl font-bold">QRSP Cooperative</h3>
          </div>
          <p className="text-gray-400 mb-4">
            Por motoristas, para motoristas. Construindo o futuro da mobilidade urbana em São Paulo.
          </p>
          <p className="text-sm text-gray-500">
            © 2024 QRSP Cooperative. Uma iniciativa dos motoristas paulistas.
          </p>
        </div>
      </div>
    </div>
  );
};